import { render, staticRenderFns } from "./CountryFilterByRegion.vue?vue&type=template&id=6885aa2d"
import script from "./CountryFilterByRegion.vue?vue&type=script&lang=js"
export * from "./CountryFilterByRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports